export const SET_ARRAY_DATA = "projectGroup/SET_ARRAY_DATA";
